module.exports = __webpack_public_path__ + "img/q1.2dad1b7e.jpg";